import styled from 'styled-components'

import { SchoolPlugin } from 'packages/sdks-next/growp'

import { AppCard } from './components/AppCard'

/**
 * 置顶卡片
 *
 * @param param - 参数
 * @param param.schoolPlugins - 置顶应用
 * @returns 组件
 */
export const PinnedCard: React.FC<{ schoolPlugins: SchoolPlugin[] }> = ({
  schoolPlugins,
}) => (
  <Box>
    <Title>{'置顶应用'}</Title>
    <ContentBox>
      {schoolPlugins.map((item) => (
        <AppCard
          key={item.id}
          schoolPlugin={item}
          isForground={true}
        />
      ))}
    </ContentBox>
  </Box>
)

const Box = styled.div`
  border-radius: 12px;
  background-color: #fff;
  padding: 20px;
  width: 100%;
  box-shadow: 0px 3px 8px -1px rgba(21, 29, 41, 0.0392);
  max-width: 1600px;
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  height: 26px;
  color: ${(props) => props.theme.text._1};
  margin-bottom: 20px;
  width: 100%;
`

const ContentBox = styled.div`
  gap: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(245px, 1fr));
`
